import React, { useMemo } from 'react';
import { Card, List, Badge, Progress } from 'antd';
import { DisposalMethod } from '../../../constants/debtEnums';

const Checklist = ({ value, current }) => {
  const items = useMemo(() => {
    const arr = [];
    // Step 1: 基本信息
    arr.push({ name: '标题', done: !!value.title });
    arr.push({ name: '债权类型', done: !!value.debt_type });
    arr.push({ name: '本金金额>0', done: Number(value.principal_amount || 0) > 0 });
    arr.push({ name: '债权发生日', done: !!value.debt_occurrence_date });
    // Step 2: 处置方式
    const isLow = value.disposal_method === DisposalMethod.LOW_PRICE_TRANSFER;
    arr.push({ name: '处置方式', done: !!value.disposal_method });
    if (isLow) {
      arr.push({ name: '低价转让设置（定价或折扣）', done: !!value.transfer_pricing_amount || !!value.transfer_discount_rate });
    }
    // Step 3: 债权人
    const isPersonal = value?.creditor?.creditor_type === 'P';
    arr.push({ name: '债权人类型', done: !!value?.creditor?.creditor_type });
    if (isPersonal) {
      arr.push({ name: '债权人个人姓名', done: !!value?.creditor?.name });
      arr.push({ name: '债权人身份证号', done: !!value?.creditor?.id_card_no });
    } else {
      arr.push({ name: '债权人企业名称', done: !!value?.creditor?.company_name });
      arr.push({ name: '债权人统一社会信用代码', done: !!value?.creditor?.social_credit_code });
    }
    // Step 4: 债务人
    const debtorCount = (value.debtorsPersonal?.length || 0) + (value.debtorsEnterprise?.length || 0);
    arr.push({ name: '至少一名债务人', done: debtorCount > 0 });
    // Step 5: 证据材料
    arr.push({ name: '至少一条证据材料', done: (value.evidences?.length || 0) > 0 });
    return arr;
  }, [value]);

  const doneCount = items.filter(i => i.done).length;
  const percent = Math.round((doneCount / items.length) * 100);

  return (
    <Card title="检查清单" className="card-compact checklist-card" size="small">
      <div className="checklist-progress">
        <Progress percent={percent} status={percent === 100 ? 'success' : 'active'} />
      </div>
      <List
        size="small"
        dataSource={items}
        renderItem={(item, idx) => (
          <List.Item>
            <Badge status={item.done ? 'success' : 'error'} text={item.name} />
          </List.Item>
        )}
      />
      <div className="checklist-footer">当前步骤：{current + 1}</div>
    </Card>
  );
};

export default Checklist;
